<img src="{{course.splash_image_url}}" width="900" height="506" />